import constant from '@core/app/actions/beambox/constant';
import type { LayerModuleType } from '@core/app/constants/layer-module/layer-modules';
import { LayerModule } from '@core/app/constants/layer-module/layer-modules';
import { useDocumentStore } from '@core/app/stores/documentStore';
import workareaManager from '@core/app/svgedit/workarea';
import { getData } from '@core/helpers/layer/layer-config-helper';
import { getAllLayers } from '@core/helpers/layer/layer-helper';

import { getSvgContentActualBBox } from './file/export/utils/getBBox';

export const getRefModule = (): LayerModuleType => {
  const firstLayer = getAllLayers()
    .reverse()
    .find((layer) => layer.getAttribute('display') !== 'none');

  if (!firstLayer) {
    return LayerModule.LASER_UNIVERSAL;
  }

  return getData(firstLayer, 'module') as LayerModuleType;
};

const getJobOrigin = async (px = false): Promise<{ x: number; y: number }> => {
  const { maxY, width: workareaWidth } = workareaManager;
  const boundary = await getSvgContentActualBBox();
  const left = Math.max(boundary.x, 0);
  const top = Math.max(boundary.y, 0);
  const right = Math.min(boundary.x + boundary.width, workareaWidth);
  const bottom = Math.min(boundary.y + boundary.height, maxY);
  const jobOrigin = useDocumentStore.getState()['job-origin'];
  const xRef = (jobOrigin - 1) % 3;
  const yRef = Math.floor((jobOrigin - 1) / 3);
  const res = { x: 0, y: 0 };

  if (xRef === 0) {
    res.x = left;
  } else if (xRef === 1) {
    res.x = (left + right) / 2;
  } else {
    res.x = right;
  }

  if (yRef === 0) {
    res.y = top;
  } else if (yRef === 1) {
    res.y = (top + bottom) / 2;
  } else {
    res.y = bottom;
  }

  if (!px) {
    res.x /= constant.dpmm;
    res.y /= constant.dpmm;
  }

  return res;
};

export default getJobOrigin;
